export enum auditScheduleStatus {
  CONFIRMED = "confirmed",
  INTERRIM = "Interim",
}
